'use client';

import { useEffect, useRef } from 'react';

export function usePrevious<T>(value: T): T | undefined;
export function usePrevious<T>(value: T, initialValue: T): T;

/**
 * Returns the value from the previous render.
 */
export function usePrevious<T>(value: T, initialValue?: T): T | undefined {
    const ref = useRef(initialValue);

    useEffect(() => {
        ref.current = value;
    });

    return ref.current;
}
